import React from 'react';
import { Link } from 'react-router-dom';

import NavBar from '../components/NavBar';

export default class Home extends React.Component {
  render() {
    return (
      <div className='welcomeContainer'>   
        <div className='container mainContainer'>
          <NavBar />
           <section className='welcome'>
            <div className='content col-md-6 col-sm-12'>
              <h1 className='white'>12 Questions<br />Admin Dashboard</h1>
            </div>
          </section>
        </div>     
      </div> 
    );
  }
}


// WEBPACK FOOTER //
// ./src/containers/Home.js